import { render, staticRenderFns } from "./PasoCincoComponent.vue?vue&type=template&id=2bb91ccb&scoped=true"
import script from "./PasoCincoComponent.vue?vue&type=script&lang=js"
export * from "./PasoCincoComponent.vue?vue&type=script&lang=js"
import style0 from "./PasoCincoComponent.vue?vue&type=style&index=0&id=2bb91ccb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb91ccb",
  null
  
)

export default component.exports